import {
  createOperatorTenantResponseSchema,
  type CreateOperatorTenantRequest,
  type CreateOperatorTenantResponse,
} from '@console/types'
import { apiPost } from '../api.js'
import { fetchCsrfToken } from '../auth/api.js'

/**
 * `LGH-046`. A `409` here is a real refusal (`1C`'s own answer: the claimed-
 * phone case rolls back the whole create) — `apiPost` throws `ApiError` with
 * `status: 409` and the server's own message, same as every other typed
 * refusal this console already renders directly rather than wrapping in a
 * second result type.
 */
export async function createOperatorTenant(
  input: CreateOperatorTenantRequest,
): Promise<CreateOperatorTenantResponse> {
  const csrfToken = await fetchCsrfToken()
  return apiPost('/operator/tenants', input, csrfToken, createOperatorTenantResponseSchema)
}
